module.exports = {
  messages: {
    BUTTON_BACK: 'Volver',
    COMMUNICATION_ERROR_500_SUBLINE:
      'Estamos preparando una solución en este momento. Acepta nuestras disculpas y gracias por tu paciencia.',
    COMMUNICATION_ERROR_500_TITLE:
      'Parece que nuestros servidores se están tomando un descanso para el café.',
    JOBS_FIND_JOBS_SEARCH_BUTTON: 'Buscar ofertas de empleo',
    LOSP_SWIMP_COMPANY_LABEL: '¿En qué empresa y/o en qué ciudad?',
    LOSP_SWIMP_COMPANY_PLACEHOLDER: 'Por ejemplo, REWE GROUP en Colonia.',
    LOSP_SWIMP_CONTINUE_BUTTON: 'Continuar',
    LOSP_SWIMP_ERROR_BUTTON_PROMPT: 'Volver',
    LOSP_SWIMP_ERROR_BUTTON_SYSTEM: 'Repetir',
    LOSP_SWIMP_ERROR_TEXT_PROMPT:
      'Introduce al menos tu cargo y tu empresa. Si lo deseas, también puedes indicar tu lugar de trabajo.',
    LOSP_SWIMP_ERROR_TITLE_PROMPT: 'Sin aportaciones reales, será difícil',
    LOSP_SWIMP_LOADING_SUBTITLE:
      'y comienza a buscar trabajos adecuados para ti.',
    LOSP_SWIMP_LOADING_TITLE: 'La IA de XING crea tu perfil...',
    LOSP_SWIMP_ROLE_LABEL: '¿A qué te dedicas actualmente?',
    LOSP_SWIMP_ROLE_PLACEHOLDER:
      'Por ejemplo: soy gestora de productos y experta en Excel.',
    LOSP_SWIMP_SUBTITLE:
      'Crea ahora tu perfil de búsqueda de empleo con la IA de XING.',
    LOSP_SWIMP_TITLE_B: 'Clic, clic',
    LOSP_SWIMP_TITLE_C: 'Coincidencia rápida',
  },
};
